import {BaseContainerModel} from '../../base-container.model';
import { bl_fi_entity_file_export_RowClass } from '../../../dbschema';

export class EntityFileExportContainerModel extends BaseContainerModel {
    bl_fi_entity_file_export: bl_fi_entity_file_export_RowClass = new bl_fi_entity_file_export_RowClass();
}